module.exports = __webpack_public_path__ + "static/img/14000681.446c494e.png";